export const GET_WALLETS = "GET_WALLETS"
export const GET_WALLETS_SUCCESS = "GET_WALLETS_SUCCESS"
export const GET_WALLETS_FAILED = "GET_WALLETS_FAILED"

export const GET_WALLET = "GET_WALLET"
export const GET_WALLET_SUCCESS = "GET_WALLET_SUCCESS"
export const GET_WALLET_FAILED = "GET_WALLET_FAILED"

export const REGISTER_WALLET = "REGISTER_WALLET"
export const REGISTER_WALLET_SUCCESS = "REGISTER_WALLET_SUCCESS"
export const REGISTER_WALLET_FAILED = "REGISTER_WALLET_FAILED"

export const UPDATE_WALLET = "UPDATE_WALLET"
export const UPDATE_WALLET_SUCCESS = "UPDATE_WALLET_SUCCESS"
export const UPDATE_WALLET_FAILED = "UPDATE_WALLET_FAILED"

export const ADD_ATTACHMENT_WALLET = "ADD_ATTACHMENT_WALLET"
export const ADD_ATTACHMENT_WALLET_SUCCESS = "ADD_ATTACHMENT_WALLET_SUCCESS"
export const ADD_ATTACHMENT_WALLET_FAILED = "ADD_ATTACHMENT_WALLET_FAILED"

export const RESET_WALLET = "RESET_WALLET";

